// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m2J_","rootNoMargin":"styles_rootNoMargin__3L2NS"};